import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
// import { getFormValues } from 'redux-form';

import _cloneDeep from 'lodash/cloneDeep';
import _last from 'lodash/fp/last';
import _isNaN from 'lodash/fp/isNaN';

import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import createGeneralForm from '../components/forms/general';
import { createSelectOptionsFromSysEnums } from '../../shared/form-elements/select';

const mainForm = createGeneralForm({
	namespace: 'goodsEditor',
	stateNodeName: 'mainForm'
});

const TOGGLE_PROGRESS_BAR = 'goodsEditor/toggle-progress-bar';
const FETCH_GOODS_SUCCESS = 'goodsEditor/fetch-applicant-success';
const FETCH_ERROR = 'goodsEditor/fetch-error';
const GET_EMPTY_DATA = 'goodsEditor/get-empty-data';
const SET_DATA_TO_NULL = 'goodsEditor/set-data-to-null';
const CATEGORIES_LOOKUP_SUCCESS = 'goodsEditor/categories-lookup-success';

export const allowedPermissions = {
	'view': 'goods_view',
	'edit': 'goods_update',
	'delete': 'goods_delete',
	'create': 'goods_create'
};

const initialState = {
	data: null,
	good: null,
	showProgressBar: false,
	mainForm: mainForm.initialState,
	error: false
};

const getTabLangs = currentLanguage => state => {
	const { defaultLanguage } = state.goodsEditor;
	const langs = state.root.lists.languages;
	return langs.map(lang => ({
		...lang,
		isSelected: true,
		isActive: lang.id === currentLanguage,
		isDefault: lang.id === defaultLanguage
	}));
};

export const actions = Object.assign({

	fetchData: () => dispatch => {
		const { pathname } = window.location;
		let lastParams = parseInt(_last(pathname.split('/')));

		if (_isNaN(lastParams)) return setTimeout(() => dispatch(actions.getEmptyData()), 0);

		const request = http({
			url: `${endpoints.GOODS.BASE}/${lastParams}`,
			method: 'get',
			actions: [ FETCH_GOODS_SUCCESS, FETCH_ERROR ]
		});

		return request(dispatch);
	},

	setDataToNull: () => ({ type: SET_DATA_TO_NULL }),

	toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),

	getEmptyData: () => ({ type: GET_EMPTY_DATA}),

	goodCategoriesLookup: text => (dispatch, getState) => {
		const request = http({
			url: endpoints.LOOKUPS.GOOD_CATEGORIES,
			method: 'get',
			actions: [CATEGORIES_LOOKUP_SUCCESS, FETCH_ERROR],
			query: { query: text }
		});

		return request(dispatch).then(action => {
			if (action.type === CATEGORIES_LOOKUP_SUCCESS) {
				return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
			}
		});
	}
},
mainForm.actions
);

const reducers = Object.assign({
	[GET_EMPTY_DATA]: (state, action) => ({
		...state,
		data: {},
		showProgressBar: false
	}),
	[SET_DATA_TO_NULL]: state => ({ ...state, data: null }),
	[LOCATION_CHANGE]: (state, action) => {
		return action.payload.pathname.indexOf('/goods/edit') === -1 ? initialState : initialState;
	},
	[FETCH_GOODS_SUCCESS]: (state, action) => {
		return {
			...state,
			data: action.payload.data,
			showProgressBar: false
		};
	},
	[FETCH_ERROR]: state => ({ ...state, error: true, showProgressBar: false}),
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
},
mainForm.reducers
);

export default handleActions(reducers, _cloneDeep(initialState));

export const selectors = {
	getData: state => state.goodsEditor.data,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getProgressBar: state => state.applicantEditor.showProgressBar,
	getMainFormData: mainForm.selectors.getMainFormData,
	getError: state => state.goodsEditor.error,
	loadStatusOptions: state => createSelectOptionsFromSysEnums(state.root.lists['good-statuses']),
	getRanksOptions: state => {
		return createSelectOptionsFromSysEnums(state.root.lists['affiliate-ranks'])
			.map(ar => ({ value: ar.value.id, label: ar.label.name}))
			.filter(ar => ar.value !== 0);
	},
	getMainTabLangs: state => {
		const { currentLanguage } = state.goodsEditor.mainForm;
		return getTabLangs(currentLanguage)(state);
	},
	getCurrentLanguage: mainForm.selectors.getCurrentLanguage
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/editor/index.js